import { isNullish } from "types/guards";

export type CountlessParamOptionsT = {
  ignoreKeys?: string[];
  defaults?: Record<string, unknown>;
};

const BASE_IGNORED_KEYS = new Set([
  "p",
  "page",
  "limit",
  "offset",
  "sort",
  "reverse",
  "cursor",
  "tab",
  "requestFreshData",
  "signal",
  "t_id",
  "filters",
  "paging_data",
  "paging_item_count",
  "paging_counts_only",
  "include_paging",
]);

const isBlank = (value: unknown): boolean => {
  if (isNullish(value)) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

export const countlessPagingParam = (
  params: Record<string, unknown> | undefined,
  options: CountlessParamOptionsT = {},
): { paging_item_count?: false } => {
  const { ignoreKeys = [], defaults = {} } = options;
  const ignored = new Set(ignoreKeys);

  const hasFilter = Object.entries(params ?? {}).some(([key, value]) => {
    if (BASE_IGNORED_KEYS.has(key) || ignored.has(key)) return false;
    if (isBlank(value)) return false;
    if (key in defaults && String(value) === String(defaults[key])) return false;
    return true;
  });

  return hasFilter ? {} : { paging_item_count: false };
};
